import store from "../store";
import Constants from "../config/constants";
import { serviceBlockedUserList } from "../services/Blocked.service";

export const FETCH_INIT = "FETCH_INIT_WHATSAPP_BLOCKED_USER";
export const FETCHED = "FETCHED_WHATSAPP_BLOCKED_USER";
export const FETCHED_FAIL = "FETCHED_FAIL_WHATSAPP_BLOCKED_USER";
export const FETCHED_FILTER = "FETCHED_FILTER_WHATSAPP_BLOCKED_USER";
export const FETCH_NEXT = "FETCH_NEXT_WHATSAPP_BLOCKED_USER";
export const FILTER = "FILTER_WHATSAPP_BLOCKED_USER";
export const RESET_FILTER = "RESET_FILTER_WHATSAPP_BLOCKED_USER";
export const SET_SORTING = "SET_SORTING_WHATSAPP_BLOCKED_USER";
export const SET_FILTER = "SET_FILTER_WHATSAPP_BLOCKED_USER";
export const SET_PAGE = "SET_PAGE_WHATSAPP_BLOCKED_USER";
export const CHANGE_PAGE = "CHANGE_PAGE_WHATSAPP_BLOCKED_USER";
export const CHANGE_STATUS = "CHANGE_STATE_WHATSAPP_BLOCKED_USER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_WHATSAPP_BLOCKED_USER";
export const CREATE_DATA = "CREATE_WHATSAPP_BLOCKED_USER";
export const UPDATE_DATA = "UPDATE_WHATSAPP_BLOCKED_USER";
export const DELETE_ITEM = "DELETE_WHATSAPP_BLOCKED_USER";
export const RESET_STATE = "RESET_STATE";

export function actionFetchBlockedUserList(index = 1, sorting = {}, filter = {}) {
  const request = serviceBlockedUserList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageBlockedUserList(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterBlockedUserList(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusBlockedUserList(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterBlockedUserList() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionResetBlockedUserState() {
  return {
    type: RESET_STATE,
  };
}

export function actionSetPageBlockedUserList(page) {
  const stateData = store.getState().blocked_user;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchBlockedUserList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
